import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CarouselComponent } from './carousel.component';
import { CarouselCreateComponent } from './carousel-create/carousel-create.component';
import { CarouselFormComponent } from './shared/carousel-form.component';
import { CarouselEditComponent } from './carousel-edit/carousel-edit.component';
import { DragulaModule, DragulaService } from 'ng2-dragula';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    DragulaModule
  ],
  declarations: [CarouselComponent, CarouselCreateComponent, CarouselEditComponent, CarouselFormComponent],
  providers: [DragulaService]
})
export class CarouselModule { }



// WEBPACK FOOTER //
// ./src/app/carousel/carousel.module.ts